// Explore's frame: cruise's own blocks alone, with no game layer spliced in.
// Kept apart from src/explore.ts (which needs a page) so a test can compose
// and check the order with no renderer, the way src/playSystems.ts does for
// play's own composition.
import type { FrameSystem } from './frame';
import type { CruiseSystems } from './cruise/systems';

export interface ExploreSystemParts {
  /** The paused frame's list, whole. */
  menu: readonly FrameSystem[];
  /** Cruise's own live block: `flight`, wrapped the way `createCruiseSim` hands it back. */
  live: CruiseSystems;
  /** The view after the drive: camera, names, rebase, scene, render, HUD. */
  view: readonly FrameSystem[];
}

export function composeExploreSystems(parts: ExploreSystemParts): FrameSystem[] {
  return [...parts.menu, ...parts.live.live, ...parts.view];
}

/** Explore's frame as it boots today: play's own order minus the game's splices. */
export const EXPLORE_SYSTEMS_ORDER: readonly string[] = [
  'menu-flight-field', 'menu-bodies', 'menu-parent-carry',
  'menu-field-refill', 'menu-coast', 'menu-trajectory', 'menu-trajectory-caption', 'menu-stage',
  'flight', 'camera', 'body-labels*', 'rebase', 'scene-misc*', 'render', 'hud',
];
